export const featuredPortfolio = [
  {
    id: 1,
    title: 'Kubernetes Visualizer',
    img: '../assets/k8.png',
    github: 'https://github.com/oslabs-beta/ECRI-40-OSP-4',
    visit: 'https://github.com/oslabs-beta/ECRI-40-OSP-4',
  },
  {
    id: 2,
    title: 'E Commerce',
    img: '../assets/ecommerce.png',
    github: 'https://github.com/ShahmarAliyev/e-commerce',
    visit: 'https://voluble-mousse-1aee47.netlify.app/',
  },
  {
    id: 4,
    title: 'Nasa Mission Control',
    img: '../assets/nasa.png',
    github: 'https://github.com/ShahmarAliyev/nasa-node',
    visit: 'https://github.com/ShahmarAliyev/nasa-node',
  },
  {
    id: 3,
    title: 'Food Menu',
    img: '../assets/food.png',
    github: 'https://github.com/ShahmarAliyev/nextjs-food',
    visit: 'https://sergiotacos.vercel.app/',
  },
];
